import { useForm } from "react-hook-form"
import IndividualInfo from "./IndividualInfo"
import AddressInfo from "./AddressInfo"
import MedicalInfo from "./MedicalInfo"
import usePatient from "@hooks/usePatient"
import { useState } from "react"
import { useNavigate } from "react-router"
const AddRegisteredPatientForm = () => {
  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      email: "",
      contact: "",
      firstName: "",
      lastName: "",
      country: "",
      province: "",
      pincode: "",
      address: "",
      eye: "",
    },
  })
  const [clickedButton, setShowClickedButton] = useState(null)

  const { handleAddPatient } = usePatient()
  const navigate = useNavigate()

  const formSubmit = (data) => {
    let addRegisteredPatientSuccess
    if (clickedButton === "save") {
      addRegisteredPatientSuccess = () => {
        navigate("/manage-patient-vision")
      }
    } else {
      addRegisteredPatientSuccess = () => {
        navigate(`/subscribe?email=${data.email}&name=${data.firstName}`)
      }
    }

    handleAddPatient(data, addRegisteredPatientSuccess)
  }
  return (
    <form
      onSubmit={handleSubmit(formSubmit)}
      className="flex gap-4 md:gap-10 flex-wrap max-w-[22rem] md:max-w-none w-full"
    >
      <IndividualInfo
        watch={watch}
        control={control}
        errors={errors}
        setValue={setValue}
        reset={reset}
      />

      <AddressInfo watch={watch} control={control} errors={errors} />

      <MedicalInfo
        watch={watch}
        control={control}
        errors={errors}
        setShowClickedButton={setShowClickedButton}
      />
    </form>
  )
}

export default AddRegisteredPatientForm
